import { get, post } from "api/apiBridges/httpBridge";
import { useCallback, useEffect, useMemo, useState, useRef } from "react";
import Button from '@mui/material/Button';
import { 
    Box, Dialog, IconButton, MenuItem, Select, Typography, 
    FormControl, InputLabel, 
    Drawer,
    Card,
    CardContent
} from "@mui/material";
import Scrollbars from "rc-scrollbars";
import { useSelector } from "react-redux";
import { loginSelector } from "store/slices/loginSlice";
import CryptoJS from "crypto-js";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

// Твои компоненты
import { useLocalNotifications } from "components/Events";
import UserAvatar from "./UserAvatar";
import { getDataSource } from "api/ds";
import { ReportTable } from "components/reportTable";
import usePreventDoubleClick from "components/AntiDBC";
import { ImgMagazine, SelectMarketLocal } from 'components/SelectMarket';
import Loading from 'components/Load';
import { colors } from "styles/colors";
import { useNavigate } from "react-router-dom";
import { useDataContextDeal } from "actions/contextDealClient";
import { ElementInfo } from "components/ElementInfo";
import { ShowModal } from "components/Modal";


export default function ReturnsDealList({ ds, type}) {

    const [open, setOpen] = useState(undefined)
    /** @type {[Array<any>, Function]} */
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true);
    const [unsavedChanges, setUnsavedChanges] = useState(false);
    const eids = getDataSource('EIDeal')

    const { company_id } = useSelector(
        loginSelector
    );

    const togleEI = (deal) => {
        if (!deal && unsavedChanges) {
            ShowModal(
                'Несохраненные изменения',
                <div>У вас есть несохраненные данные. Вы уверены, что хотите закрыть шторку?</div>,
                async () => {
                    setOpen(deal)
                }
            );
            return;
        }
        setOpen(deal)
    }    

    const fetchData = async () => {
        try {
            setLoading(true)
            let res = []
            if (type === 'returns') {
                res = await get("Deal/getCompanyReturns", {cid: company_id})
            }            
            if (type === 'selfreturns') {
                res = await get("Deal/getCompanySelfReturns", {cid: company_id})
            }            
            setData(res)
        }
        catch {}
        finally {setLoading(false)}
    }

    useEffect(() => {
        fetchData();
    }, []);

    if (loading) {return (<Loading/>);}

    return (
        <div style={{width: "98%", margin:"1%", height: "98%", display: 'flex', flexDirection: 'column'}}>
            <div 
                style={{
                    backgroundColor: '#fff',
                    borderRadius: '10px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                    padding: '20px 24px',
                    width: '100%',
                    height: "15%",
                    marginTop: "2%"
                }}
            >
                <div 
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'stretch',
                        gap: '16px'
                    }}
                >
                    <div 
                        style={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column'
                        }}
                    >
                        <Typography 
                            style={{
                                fontWeight: 'normal',
                                color: 'gray',
                                fontSize: '14pt',
                                marginBottom: '4px'
                            }}
                        >
                            Количество сделок
                        </Typography>
                        <Typography 
                            style={{
                                fontWeight: 'normal',
                                fontSize: '30pt',
                                textAlign: 'right'
                            }}
                        >
                            {data.length}
                        </Typography>
                    </div>
                </div>
            </div>
            <div 
                style={{
                    width: '100%',
                    height: "83%",
                    marginTop: "10px"
                }}
            >
                <Scrollbars style={{height: "100%", width: "100%"}}>
                    {data.map((deal) => 
                        <Card
                            sx={{
                                margin: '5px 1% 0px 1%',
                                width: '98%',
                                backgroundColor: 'white',
                                borderRadius: "10px",
                                cursor: 'pointer',
                                transition: 'background-color 0.2s ease',
                                '&:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.12)', // затемнение при наведении
                                },
                            }}
                            onClick={() => togleEI(deal.id)}
                            >
                            <CardContent
                                sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                p: '8px 16px',       // компактные отступы
                                '&:last-child': { pb: '8px' },
                                }}
                            >
                                <div style={{width: '40%'}}>
                                    <Typography sx={{ fontWeight: 'normal', fontSize: '14pt' }}>
                                        #{deal.cdn} {deal.client_id}-{deal.name}
                                    </Typography>
                                </div>
                                <div style={{width: '40%'}}>
                                    <Typography variant="body2" color="text.secondary">
                                        sku: {deal.sku}, кол: {deal.units}
                                    </Typography>
                                </div>
                                <ImgMagazine magazine={deal.market} size={20} user_id={deal.client_id}></ImgMagazine>
                            </CardContent>
                            </Card>
                    )}
                </Scrollbars>
            </div>
            <Drawer
                anchor='right'
                open={open}
                onClose={() =>{togleEI(undefined)}}
                // hideBackdrop 
                sx={{
                    '& .MuiBackdrop-root': {
                    backgroundColor: 'rgba(0, 0, 0, 0)',
                    },
                }}
            >
                <ElementInfo 
                ds={eids} 
                data={open} 
                // @ts-ignore
                setChanged={setUnsavedChanges} 
                />
            </Drawer>
        </div>
    )
}